import { NgClass } from '@angular/common';
import { Component, HostBinding, Input, OnChanges, forwardRef } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CheckboxComponentDef } from '@df/ui/form/checkbox';
@Component({
    selector: 'checkbox',
    templateUrl: 'checkbox.html',
    styleUrls: ['checkbox.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true
        }
    ],
    standalone: true,
    imports: [NgClass, FormsModule]
})
export class CheckboxComponent extends CheckboxComponentDef implements OnChanges{
    @Input()
    @HostBinding('class.checkbox-top')
    top = false;
    @HostBinding('class.checkbox')
    getCheckbox = true;
    @HostBinding('class.is-checked')
    get getIsChecked() {
        return this.checked;
    }
    @HostBinding('class.is-disabled')
    get getIsDisabled() {
        return this.disabled;
    }

    ngOnChanges(): void {
        this.ref.detectChanges();
    }
}
